import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Subscription } from 'rxjs';
import { SpinnerService } from './spinner.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalSpinnerService {
  private globalSpinner: HTMLElement | null = null;
  private fallbackTimeout: any;
  private loadingSubscription: Subscription | null = null;

  constructor(
    private spinnerService: SpinnerService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  init() {
    if (isPlatformBrowser(this.platformId)) {
      this.globalSpinner = document.getElementById('global-spinner');

      if (!this.globalSpinner) return;

      // Fallback: Hide after 2 seconds if no loading happens
      this.fallbackTimeout = setTimeout(() => {
        this.addHiddenClassAndHide();
      }, 2000);

      // Subscribe to loading$ to hide spinner after requests
      this.loadingSubscription = this.spinnerService.loading$.subscribe((loading) => {
        if (!loading) {
          clearTimeout(this.fallbackTimeout);
          this.addHiddenClassAndHide();
        }
      });
    }
  }

  private addHiddenClassAndHide() {
    if (this.globalSpinner) {
      this.globalSpinner.classList.add('hidden');
      setTimeout(() => {
        this.globalSpinner!.style.display = 'none';
      }, 1000);
    }
  }

}
